import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FieldWrap } from "@/components/Field";
import { api, errMsg } from "@/lib/api";

export function ForgotDialog({ open, onClose, initial = "" }) {
  const [email, setEmail] = useState(initial);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const close = () => { setSent(false); setError(""); onClose(); };
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); } catch (err) { setError(errMsg(err)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-sm" data-testid="forgot-dialog">
        <DialogHeader><DialogTitle>Forgot password</DialogTitle></DialogHeader>
        {sent ? (
          <div className="space-y-4">
            <p className="text-sm text-slate-700" data-testid="forgot-sent">If this login exists, we sent a reset link to its email address. The link works for 1 hour. Check your spam folder too.</p>
            <Button className="w-full" onClick={close} data-testid="forgot-done">OK</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <FieldWrap label="Email or username"><Input className="h-11" value={email} onChange={(e) => setEmail(e.target.value)} required autoCapitalize="none" data-testid="forgot-email-input" /></FieldWrap>
            {error && <p className="text-sm text-red-700" data-testid="forgot-error">{error}</p>}
            <Button type="submit" className="w-full" data-testid="forgot-submit">Send reset link</Button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
